'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileCreateNewFolder = function FileCreateNewFolder(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-1 8h-3v3h-2v-3h-3v-2h3V9h2v3h3v2z' })
  );
};
FileCreateNewFolder = (0, _pure2.default)(FileCreateNewFolder);
FileCreateNewFolder.displayName = 'FileCreateNewFolder';
FileCreateNewFolder.muiName = 'SvgIcon';

exports.default = FileCreateNewFolder;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/file/create-new-folder.js
// module id = 1432
// module chunks = 0